import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";
import { environment } from "src/environments/environment";
import { AuthService } from "src/app/shared/services/auth.service";
import { Subscription } from "rxjs";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
  standalone: false
})
export class SidebarComponent implements OnInit {
  menu: any;
  toggle: any = true;
  menuItems: MenuItem[] = [];
  @ViewChild("sideMenu") sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  permissionSubscription: Subscription | undefined;
  permissions: any[] = [];
  defaultMenu = "/";

  constructor(private router: Router, private authService: AuthService, public helper: Helper) {}

  ngOnInit(): void {
    this.permissionSubscription = this.authService.authPermission.subscribe((permissions) => {
      this.permissions = permissions;
      this.menuItems = MENU;
    });
    // Menu Items
    this.router.events.subscribe((event) => {
      if (document.documentElement.getAttribute("data-layout") !== "twocolumn" && event instanceof NavigationEnd) {
        this.initActiveMenu();
      }
    });
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initActiveMenu();
    }, 0);
  }

  removeActivation(items: any): void {
    items.forEach((item: any) => {
      item.classList.remove("active");
    });
  }

  toggleItem(item: any): void {
    this.menuItems.forEach((menuItem: any) => {
      if (menuItem === item) {
        menuItem.isCollapsed = !menuItem.isCollapsed;
      } else {
        menuItem.isCollapsed = true;
      }
      if (menuItem.subItems) {
        menuItem.subItems.forEach((subItem: any) => {
          if (subItem === item) {
            menuItem.isCollapsed = !menuItem.isCollapsed;
            subItem.isCollapsed = !subItem.isCollapsed;
          } else {
            subItem.isCollapsed = true;
          }
          if (subItem.subItems) {
            subItem.subItems.forEach((childitem: any) => {
              if (childitem === item) {
                childitem.isCollapsed = !childitem.isCollapsed;
                subItem.isCollapsed = !subItem.isCollapsed;
                menuItem.isCollapsed = !menuItem.isCollapsed;
              } else {
                childitem.isCollapsed = true;
              }
              if (childitem.subItems) {
                childitem.subItems.forEach((childrenitem: any) => {
                  if (childrenitem === item) {
                    childrenitem.isCollapsed = false;
                    childitem.isCollapsed = false;
                    subItem.isCollapsed = false;
                    menuItem.isCollapsed = false;
                  } else {
                    childrenitem.isCollapsed = true;
                  }
                });
              }
            });
          }
        });
      }
    });
  }

  activateParentDropdown(item: any): boolean {
    item.classList.add("active");
    const parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
        }
      }
    }
    return false;
  }

  updateActive(event: any): void {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
  }

  initActiveMenu(): void {
    let pathName = window.location.pathname;
    // Check if the application is running in production
    if (environment.production) {
      // Modify pathName for production build
      pathName = pathName.replace("/velzon/angular/master", "");
    }

    const active = this.findMenuItem(pathName, this.menuItems);
    this.toggleItem(active);
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      const activeItems = items.filter((x: any) => x.classList.contains("active"));
      this.removeActivation(activeItems);

      const matchingMenuItem = items.find((x: any) => {
        if (environment.production) {
          let path = x.pathname;
          path = path.replace("/velzon/angular/master", "");
          return path === pathName;
        }
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }

  private findMenuItem(pathname: string, menuItems: any[]): any {
    for (const menuItem of menuItems) {
      if (menuItem.link && menuItem.link === pathname) {
        return menuItem;
      }

      if (menuItem.subItems) {
        const foundItem = this.findMenuItem(pathname, menuItem.subItems);
        if (foundItem) {
          return foundItem;
        }
      }
    }

    return null;
  }
  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem): boolean {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(): void {
    const sidebarsize = document.documentElement.getAttribute("data-sidebar-size");
    if (sidebarsize === "sm-hover-active") {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover-active");
    }
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide(): void {
    document.body.classList.remove("vertical-sidebar-enable");
  }

  filteredMenuItems(menuItems: MenuItem[]): MenuItem[] {
    return menuItems
      ? menuItems.filter((_mainmenu) =>
          _mainmenu.subItems
            ? this.filteredMenuItems(_mainmenu.subItems).length
            : _mainmenu.role === this.defaultMenu || this.authService.isMainAdminLogin || this.permissions?.some((x) => x.name === _mainmenu.role)
        )
      : [];
  }
}
